(() => {
  const article = document.querySelector('#evp-adv2');
  const productMedia = document.querySelector('#adv2-product-media');
  if (!article) return;
  article.querySelectorAll('.feature-img').forEach((frame) => {
    if (!frame.querySelector('img,video') && productMedia) {
      frame.append(productMedia.content.cloneNode(true));
    }
  });
  const hero = article.querySelector('.hero-image img');
  if (hero) {
    hero.loading = 'eager';
    hero.fetchPriority = 'high';
  }

})();
